var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDmfLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 228.5,
    height: 100.53,
    viewBox: "0 0 228.5 100.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5882",
    "data-name": "Rectangle 5882",
    width: 228.5,
    height: 100.53,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artwork_10",
    "data-name": "Artwork 10",
    transform: "translate(114.25 50.265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artwork_10-2",
    "data-name": "Artwork 10",
    transform: "translate(-114.25 -50.265)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21784",
    "data-name": "Path 21784",
    d: "M75.3,68.3,47.5,96h-.2L4.5,53.1a.1.1,0,1,1,0-.2l5.1-5.1h.2L38.7,76.7h.2l2-2a.2.2,0,0,0,0-.2l-31-31H9.5L.1,52.9a.2.2,0,0,0,0,.3l47.2,47.2h.3L79.8,68.3a.2.2,0,0,0,0-.3L49.9,38.2a.4.4,0,0,1,0-.6,23.1,23.1,0,0,0-8-35.7C36.6-.7,27.9-.6,22.6,2a23,23,0,0,0-6.5,37.1L53.8,76.7H54l2-2a.2.2,0,0,0,0-.2l-38-38A18.9,18.9,0,0,1,13.7,16C19.6,1.6,36.7-.7,46.3,8.9a19.8,19.8,0,0,1,1.4,26.4.4.4,0,0,1-.6,0L32.5,20.8h-.3l-8.4,8.4a.2.2,0,0,0,0,.2l2,2H26l6.2-6.2h.2L75.3,68.1a.1.1,0,0,1,0,.2",
    fill: "#00a7ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21785",
    "data-name": "Path 21785",
    d: "M112,17.5a12.5,12.5,0,0,1-3.4,9Q105.2,30,99.3,30H88V28.2h3.3V6.9H88V5H99.2q6.1,0,9.4,3.6a12.6,12.6,0,0,1,3.4,9m-2.4,0A11,11,0,0,0,107,9.9q-2.7-3-7.8-3H93.5V28.2h5.6q5.1,0,7.8-2.9a11,11,0,0,0,2.7-7.7",
    fill: "#002a48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21786",
    "data-name": "Path 21786",
    d: "M138.5,30.1h-8.6v-2h3.7l-2.1-5.5H120.2L118,28.1h4v2h-8.6v-2h2.4l8.5-21.2h-4.1V5H127l9,23.2h2.6Zm-7.6-9.2L126.1,8.2h-.2l-5,12.7Z",
    fill: "#002a48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21787",
    "data-name": "Path 21787",
    d: "M165.8,6.9h-3.2V30.1h-1.5L146.2,9.3H146V28.1h4.2v2h-9.3v-2h3V6.9h-3.4V5h5.1l14.7,20.5h.1V6.9h-3.8V5h9.2Z",
    fill: "#002a48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21788",
    "data-name": "Path 21788",
    d: "M186.6,23.2a6.3,6.3,0,0,1-2.6,5.4,10.2,10.2,0,0,1-6.2,1.9,17.8,17.8,0,0,1-4.5-.5,10.7,10.7,0,0,1-3.2-1.4l.5-4.6,1.8.2-.2,3.2a9,9,0,0,0,2.6.9l2.9.3a8.5,8.5,0,0,0,4.5-1.2,4.3,4.3,0,0,0,1.9-3.9q0-3.1-2.1-4a23.4,23.4,0,0,0-4.5-1.5L174,17a6.7,6.7,0,0,1-2.9-1.9,5.4,5.4,0,0,1-1.1-3.7,6,6,0,0,1,2.2-5.1,8.8,8.8,0,0,1,5.5-1.7,16.9,16.9,0,0,1,4.1.5,9.9,9.9,0,0,1,3.3,1.4l.2,4.9-1.8.2-.4-4a8.4,8.4,0,0,0-2.6-.8L178,6.6a6.7,6.7,0,0,0-4.2,1.2,4,4,0,0,0-1.6,3.4,3.4,3.4,0,0,0,1.9,3.4,23.3,23.3,0,0,0,4.1,1.4l3.6,1a7.7,7.7,0,0,1,3.2,2,6,6,0,0,1,1.3,4.2",
    fill: "#002a48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21789",
    "data-name": "Path 21789",
    d: "M213.4,30.1h-8.5v-2H208l-7.2-9.8h-4.4v9.8h3v2h-8.6v-2h3.3V6.9h-3.3V5h8.7V6.9h-3.1v9.4h4.3l7-9.4h-3.2v-2h8.4v2H210l-7.5,10.2,8.1,11h2.8Z",
    fill: "#002a48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21790",
    "data-name": "Path 21790",
    d: "M118.7,40.2h-3.4V61.4h3.3v2H110v-2h3.1V43.7h-.2L104,62.3h-1.4l-9-18.6h-.1V61.4h3.1v2H88.1v-2h3.2V40.2H88v-2h5.3l10,20.8h.2l9.8-20.8h5.4Z",
    fill: "#002a48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21791",
    "data-name": "Path 21791",
    d: "M147.3,50.8a13.5,13.5,0,0,1-1.6,6.5A12.583,12.583,0,0,1,128.2,62a12.3,12.3,0,0,1-4.4-4.7,13.6,13.6,0,0,1-1.6-6.5,13.4,13.4,0,0,1,1.6-6.5,12.3,12.3,0,0,1,4.4-4.7,12.728,12.728,0,0,1,17.4,4.7,13.6,13.6,0,0,1,1.6,6.5m-2.4,0A11.4,11.4,0,0,0,142,43a9.4,9.4,0,0,0-7.4-3.2,9.2,9.2,0,0,0-7.4,3.2,11.5,11.5,0,0,0-2.7,7.7,11.6,11.6,0,0,0,2.7,7.7,10.2,10.2,0,0,0,14.9.1,11.5,11.5,0,0,0,2.7-7.7",
    fill: "#002a48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21792",
    "data-name": "Path 21792",
    d: "M172.4,45.7l-2,.1-.8-5.6h-7.2V61.4h4.5v2H155.8v-2h4.4V40.2h-7.1l-.8,5.6-2-.1.7-7.5h20.6Z",
    fill: "#002a48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21793",
    "data-name": "Path 21793",
    d: "M200.5,50.8a13.5,13.5,0,0,1-1.6,6.5A12.583,12.583,0,0,1,181.4,62a12.3,12.3,0,0,1-4.4-4.7,13.6,13.6,0,0,1-1.6-6.5,13.4,13.4,0,0,1,1.6-6.5,12.4,12.4,0,0,1,4.4-4.7,12.728,12.728,0,0,1,17.4,4.7,13.5,13.5,0,0,1,1.6,6.5m-2.4,0a11.4,11.4,0,0,0-2.8-7.8,9.4,9.4,0,0,0-7.4-3.2,9.2,9.2,0,0,0-7.4,3.2,11.5,11.5,0,0,0-2.7,7.7,11.6,11.6,0,0,0,2.7,7.7,10.2,10.2,0,0,0,14.9.1,11.5,11.5,0,0,0,2.7-7.7",
    fill: "#002a48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21794",
    "data-name": "Path 21794",
    d: "M225.7,63.4H221l-5.5-10.8h-5.9v8.8h3.6v2h-9.1v-2h3.3V40.2h-3.3v-2h10.7q4.7,0,6.6,2.1a7.1,7.1,0,0,1,1.9,4.9,7.4,7.4,0,0,1-1.4,4.4,6.8,6.8,0,0,1-4.2,2.6l4.8,9.2h3.2Zm-4.8-18.1a4.7,4.7,0,0,0-1.5-3.8q-1.5-1.3-4.8-1.3h-5V50.7h5.1q3.3,0,4.8-1.5a5.4,5.4,0,0,0,1.5-4",
    fill: "#002a48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21795",
    "data-name": "Path 21795",
    d: "M107.4,79.1l-3.7.3-.8-4.2H95.1v8.1h11v3.6h-11V93h4.3v3.7H87.9V93h2.9V75.2H87.9V71.5h18.7Z",
    fill: "#092540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21796",
    "data-name": "Path 21796",
    d: "M120.6,96.7h-10V93h2.9V75.2h-2.9V71.5h10v3.7h-2.8V93h2.8Z",
    fill: "#092540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21797",
    "data-name": "Path 21797",
    d: "M151,75.2h-2.9V96.7h-2.5l-14-17.4h-.1V93h3.7v3.7H124.7V93h2.7V75.2h-3.1V71.5h6.3l13.3,16.7h.1v-13h-3.7V71.5H151Z",
    fill: "#092540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21798",
    "data-name": "Path 21798",
    d: "M178,96.7h-9.6V93H171l-1.3-3.4h-9.4L158.9,93h2.8v3.7h-9.5V93h2.3l7.6-17.8h-3.7V71.5h8.1L175.6,93H178Zm-9.5-10.3-3.3-8.8H165l-3.5,8.8Z",
    fill: "#092540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21799",
    "data-name": "Path 21799",
    d: "M206.7,75.2h-2.9V96.7h-2.5l-14-17.4h-.1V93h3.7v3.7H180.4V93h2.8V75.2H180V71.5h6.3l13.3,16.7h.1v-13h-3.6V71.5h10.6Z",
    fill: "#092540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21800",
    "data-name": "Path 21800",
    d: "M228.5,89.3a6.9,6.9,0,0,1-2.6,5.8,11,11,0,0,1-6.9,2,19.6,19.6,0,0,1-4.9-.6,9.6,9.6,0,0,1-3.8-1.8l.7-5.8,3.4.3v3.1a8.1,8.1,0,0,0,2.3.8l2,.2a8.6,8.6,0,0,0,3.7-.7,2.9,2.9,0,0,0,1.5-2.9,3.1,3.1,0,0,0-1.7-3.2,16.8,16.8,0,0,0-3.9-1.2l-3.6-.9a6.6,6.6,0,0,1-3-1.9,5.8,5.8,0,0,1-1.2-4q0-4,2.7-5.7a10.9,10.9,0,0,1,6-1.7,14.8,14.8,0,0,1,4.5.7,9.2,9.2,0,0,1,3.4,1.8l.2,5.3-3.4.3-.4-3.3a7.6,7.6,0,0,0-2.2-.9l-2.1-.2a5.7,5.7,0,0,0-3,.7,3,3,0,0,0,.3,4.9,17.6,17.6,0,0,0,3.4,1.1l3.6.9a8,8,0,0,1,3.5,2.1,6.3,6.3,0,0,1,1.5,4.6",
    fill: "#092540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21801",
    "data-name": "Path 21801",
    d: "M107.4,79.1l-3.7.3-.8-4.2H95.1v8.1h11v3.6h-11V93h4.3v3.7H87.9V93h2.9V75.2H87.9V71.5h18.7Z",
    fill: "#002a48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21802",
    "data-name": "Path 21802",
    d: "M120.6,96.7h-10V93h2.9V75.2h-2.9V71.5h10v3.7h-2.8V93h2.8Z",
    fill: "#002a48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21803",
    "data-name": "Path 21803",
    d: "M151,75.2h-2.9V96.7h-2.5l-14-17.4h-.1V93h3.7v3.7H124.7V93h2.7V75.2h-3.1V71.5h6.3l13.3,16.7h.1v-13h-3.7V71.5H151Z",
    fill: "#002a48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21804",
    "data-name": "Path 21804",
    d: "M178,96.7h-9.6V93H171l-1.3-3.4h-9.4L158.9,93h2.8v3.7h-9.5V93h2.3l7.6-17.8h-3.7V71.5h8.1L175.6,93H178Zm-9.5-10.3-3.3-8.8H165l-3.5,8.8Z",
    fill: "#002a48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21805",
    "data-name": "Path 21805",
    d: "M206.7,75.2h-2.9V96.7h-2.5l-14-17.4h-.1V93h3.7v3.7H180.4V93h2.8V75.2H180V71.5h6.3l13.3,16.7h.1v-13h-3.6V71.5h10.6Z",
    fill: "#002a48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21806",
    "data-name": "Path 21806",
    d: "M228.5,89.3a6.9,6.9,0,0,1-2.6,5.8,11,11,0,0,1-6.9,2,19.6,19.6,0,0,1-4.9-.6,9.6,9.6,0,0,1-3.8-1.8l.7-5.8,3.4.3v3.1a8.1,8.1,0,0,0,2.3.8l2,.2a8.6,8.6,0,0,0,3.7-.7,2.9,2.9,0,0,0,1.5-2.9,3.1,3.1,0,0,0-1.7-3.2,16.8,16.8,0,0,0-3.9-1.2l-3.6-.9a6.6,6.6,0,0,1-3-1.9,5.8,5.8,0,0,1-1.2-4q0-4,2.7-5.7a10.9,10.9,0,0,1,6-1.7,14.8,14.8,0,0,1,4.5.7,9.2,9.2,0,0,1,3.4,1.8l.2,5.3-3.4.3-.4-3.3a7.6,7.6,0,0,0-2.2-.9l-2.1-.2a5.7,5.7,0,0,0-3,.7,3,3,0,0,0,.3,4.9,17.6,17.6,0,0,0,3.4,1.1l3.6.9a8,8,0,0,1,3.5,2.1,6.3,6.3,0,0,1,1.5,4.6",
    fill: "#002a48"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmfLogo);
export default __webpack_public_path__ + "static/media/dmf_logo.09099f3b.svg";
export { ForwardRef as ReactComponent };